import { detailsBackground } from '../../config/colors';
import { MODULE_BACKGROUND_COLORS, primaryMatch } from './enums';

export const getModuleRowBackgroundColor = (row) => {
  const { bespoke = false, siScore = null, repeatable = false } = row;

  const condVals = [
    {
      condition: siScore === null && !bespoke,
      value: MODULE_BACKGROUND_COLORS.LIGHT_GREY,
    },
    {
      condition: repeatable,
      value: MODULE_BACKGROUND_COLORS.LIGHT_PEACH,
    },
    {
      condition: bespoke,
      value: MODULE_BACKGROUND_COLORS.PEACH,
    },
    {
      condition: siScore < 15,
      value: MODULE_BACKGROUND_COLORS.MEDIUM_GREY,
    },
    {
      condition: siScore < 65,
      value: MODULE_BACKGROUND_COLORS.DARK_GREY,
    },
    {
      condition: siScore < 85,
      value: MODULE_BACKGROUND_COLORS.YELLOW,
    },
    {
      condition: siScore <= 100,
      value: MODULE_BACKGROUND_COLORS.GREEN,
    },
    {
      condition: true,
      value: detailsBackground,
    },
  ];

  return condVals.find((cV) => cV.condition).value;
};

export const parseToFloatIfNumber = (value) => (!value || isNaN(value) ? value : parseFloat(value));
